export default "__VITE_ASSET__fd92560f__"